import { ImageWrapper } from './ImageWrapper.jsx';

/**
 * The round badge a loyalty tier or stamp category is drawn with.
 *
 * An image wins over an emoji when both are configured, so filling one in never hides
 * the other's work; with neither, the first two letters of the name stand in so the
 * badge is never an empty circle.
 */
export function LoyaltyBadge({ image, emoji, name, size = 64 }) {
  return (
    <div
      className="rounded-full border-[2px] border-[#E1E1E1] bg-mid overflow-hidden flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
    >
      {image ? (
        <ImageWrapper
          image={image}
          alt={name}
          display="block"
          width="100%"
          height="100%"
          backgroundColor="transparent"
          margin="0"
          padding="0"
          borderRadius="0"
          transition={true}
          loadDelay={0.1}
        />
      ) : emoji ? (
        <span style={{ fontSize: Math.round(size * 0.5), lineHeight: 1 }}>{emoji}</span>
      ) : (
        <span className="secondary-font-bold uppercase" style={{ fontSize: Math.round(size * 0.28) }}>
          {(name || '?').slice(0, 2)}
        </span>
      )}
    </div>
  );
}
